import 'nodelist-foreach-polyfill';
import React, {useEffect, useState} from 'react';
import {Provider} from 'react-redux';
import {BrowserRouter as Router, Redirect, Route} from 'react-router-dom';
import 'url-search-params-polyfill';
import 'webstorage-polyfill';
import LoginCheck from './components/Common/LoginCheck';
import Customer from './components/Customer';
import Main from './components/Main';
import MemberService from './components/MemberService';
import MyPcBang from './components/MyPcBang';
import News from './components/News/index';
import Payment from './components/Payment';
import Products from './components/Products';
import SystemMaintenance from './components/SystemMaintenance';
import {commonErrorHandler} from './actions/fetch.util';
import {Spinner} from './components/Common/PageComponents';
import ScrollToTop from './components/Common/ScrollTop';

import './App.scss';
import PcBangPointAgreement from './components/PcBangPointAgreement/PcBangPointAgreement';

const WithProductMeta = props => {
  const [productMeta, setProductMeta] = useState({});

  useEffect(() => {
    fetch(`${API_URL}/purchases/products/product-meta`)
      .then(commonErrorHandler)
      .then(response => response.json())
      .then(productMeta => {
        setProductMeta(productMeta);
        window.TIME_CREDIT_OVER_PC_BANG_POINT = productMeta.timeCreditOverPcBangPoint;
      });
  }, []);

  return productMeta.timeCreditOverPcBangPoint ? props.children : <Spinner />;
};

export default class App extends React.Component {
  render() {
    return (
      <Provider store={this.props.store}>
        <Router>
          <div>
            <WithProductMeta>
              <ScrollToTop />
              <Route exact path="/" component={Main} />
              <Route path="/index.asp" render={() => <Redirect to="/" />} />
              <Route path="/member-service" component={MemberService} />
              <Route path="/customer" component={Customer} />
              <Route path="/news" component={News} />
              <Route path="/products" component={Products} />
              <Route path="/my-pc-bang" component={MyPcBang} />
              <Route path="/login-check" component={LoginCheck} />
              <Route path="/payment" component={Payment} />
            </WithProductMeta>
            <Route path="/pcbang-point-agreement" component={PcBangPointAgreement} />
            <Route path="/system-maintenance" component={SystemMaintenance} />
          </div>
        </Router>
      </Provider>
    );
  }
}
